














































































































































































import { Component, Vue } from 'vue-property-decorator';

import * as STdata from '../data/data.json'

@Component
export default class AppResults extends Vue {
	parties: any = STdata.default.parties
	percentages: number[] = []
    circleGraphWidth: {desktop: number, mobile: number} = {
		desktop: 160,
		mobile: 100
	} 
	circleGraphStroke: {desktop: number, mobile: number} = {
		desktop: 20,
		mobile: 12
	}
	circleGraphPercentages: [number, number, number] = [0, 0, 0]
    delayPerResult: number = .15

	get results(): {"id": number, "percentage": number}[] {
		const results: {"id": number, "percentage": number}[] = []
		const userChoices = this.$store.getters.choices

		for (let i = 0; i < this.parties.length; i++) {
			const party = this.parties[i]
			let userLikeness = 0

			for (let j = 0; j < party.choices.length; j++) {
				if (party.choices[j].choice === userChoices[j]) userLikeness++
			}

			results.push({"id": i, "percentage": Math.round((userLikeness / (<any>this.$parent).filledInEnough()[1]) * 100)})
		}

		results.sort((a, b) => a.percentage > b.percentage ? -1 : a.percentage < b.percentage ? 1 : 0)

		return results
	}

	backToStart() {
		_paq.push(['trackEvent', 'userEvent', 'backToResult'])

		;(<any>this.$parent).goToStatement(0)
	}

	reportExternalLink(location: 'tool' | 'social'): void {
		if (location === 'tool') {
			_paq.push(['trackEvent', 'userEvent', 'goToExternalTool'])
		} else if (location === 'social') {
			_paq.push(['trackEvent', 'userEvent', 'doSocialShare']);
		}
	}

	animatePercentages(): void {
		if (this.$store.getters.resultsSeenSinceLastChange) {
			for (let i = 0; i < this.results.length; i++) {
				this.percentages.push(this.results[i].percentage)
			}
		} else {
			const app = this

			function animatePercentage(index: number) {
				setTimeout(() => {
					app.$set(app.percentages, index, app.percentages[index] + 1)

					if (app.percentages[index] < app.results[index].percentage) {
						animatePercentage(index)
					}
				}, index < 4 ? 5 : 3)
			}

			for (let i = 0; i < this.results.length; i++) {

				if (this.results[i].percentage > 0) {
					this.percentages[i] = 0

					setTimeout(() => {
						animatePercentage(i)
					}, i < 4 ? i * 200 + 300 : i * 100 + 900)

				} else {
					this.percentages[i] = 0
				}
			}
		}
	}

    radius(size: 'desktop' | 'mobile'): number {
		return ((this.circleGraphWidth[size] - this.circleGraphStroke[size]) / 2)
	}

	circumference(size: 'desktop' | 'mobile'): number {
		return (2 * Math.PI * this.radius(size))
	}

	created() {
		if ((<any>this.$parent).filledInEnough()[0]) {
			if (!this.$store.getters.resultsSeenSinceStart) {
				_paq.push(['trackEvent', 'systemEvent', 'toolFinished'])
			}

			this.animatePercentages()

			setTimeout(() => {
				this.$store.dispatch('recordResultsSeen', true)
				this.$store.dispatch('recordResultsSeenFirsTime')
			}, 50)
		} else {
			this.$store.dispatch('recordResultsSeen', false)
		}
	}
}
